export default "__VITE_ASSET__DsHy_$Fm__"